"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileFastStart = void 0;
class FileFastStart {
    constructor({ enabled }) {
        this.toJSON = () => ({
            enabled: this.enabled,
        });
        this.enabled = enabled;
    }
}
exports.FileFastStart = FileFastStart;
FileFastStart.fromJSON = (json) => {
    const { enabled } = Object.assign({}, json);
    if (enabled !== null && typeof enabled !== 'boolean')
        throw new Error('.enabled must be a boolean');
    return new FileFastStart({ enabled });
};
exports.default = FileFastStart;
